export const APPLY_LANGUAGE = 'APPLY_LANGUAGE' as const;
export const REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY = 'REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY';
